import { COLOR_PALETTE } from 'constants/ui';

export const rootStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  minWidth: 0,
  flex: 1,
};

export const loanNumberStyles = {
  color: COLOR_PALETTE.GRAY[70],
  flexShrink: 0,
};

export const clickableLoanNumberBadgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '2px 8px',
  borderRadius: '4px',
  backgroundColor: ({ palette }) => palette.action.hover,
  color: ({ palette }) => palette.text.secondary,
  flexShrink: 0,
  cursor: 'pointer',
  border: 'none',
  '&:hover': {
    backgroundColor: ({ palette }) => palette.action.selected,
  },
  '&:focus-visible': {
    outline: '2px solid',
    outlineColor: ({ palette }) => palette.primary.light,
    outlineOffset: '2px',
  },
};

export const milestoneSlotStyles = {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  maxWidth: 120,
};

export const borrowerStyles = {
  color: COLOR_PALETTE.GRAY[100],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
  flex: 1,
};

export const fallbackStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
  flex: 1,
};
